import { createTheme, ThemeProvider } from '@mui/material/styles';

import Routes from 'src/Routes';
import { COLORS } from 'src/constants';
import { AuthProvider, CountryProvider, TypeProvider} from 'src/contexts';
import { ServiceProvider, MsReferenceService, OrgService, AiService,DiService } from './services';
import serviceExports from 'src/configuration/serviceExports';

import "@cb/apricot/CBBase";
import "@cb/apricot/CBGrid";
import "@cb/apricot/CBIcon";
import "@cb/apricot/CBLogo";

const outerTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
    },
    secondary: {
      main: COLORS.secondary,
    },
  },
});


/**
 * REFACTOR: move towards an env based config at the stack instead of
 * using a giant config map based on ENV key
 * 
 * const msRefApiKey = process.env.REACT_APP_MS_REF_API_KEY;
 * const msRefHost = process.env.REACT_APP_MS_REF_HOST;
 * if (!msRefApiKey || !msRefHost)
 *   throw new Error("Incomplete configuration, unable to start app");
 * const orgSearchApiKey = process.env.REACT_APP_ORG_API_KEY;
 * const orgSearchHost = process.env.REACT_APP_ORG_HOST;
 * if (!orgSearchHost || !orgSearchApiKey)
 *   throw new Error("Incomplete configuration for org search, unable to start app");
 */

const service = MsReferenceService();
const aiService = AiService(service);
const diService = DiService(service);
const orgService = OrgService(service);

function App() {
  return (
    <ThemeProvider theme={outerTheme}>
      <AuthProvider>
          <ServiceProvider ai={aiService} di={diService} org={orgService} msReference={service} >
            <TypeProvider>
              <CountryProvider>
                <div id="mainContent">
                  <Routes />
                </div>
              </CountryProvider>
            </TypeProvider>
          </ServiceProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
